export const resolveGigImage = (src = '', useLargeImage) =>
    src.replace('t_main1', useLargeImage ? 't_gig_cards_web_x2' : 't_gig_cards_web');
